import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { Status } from '../../enums/status';

// INTERFACES
import { IStepCard } from '../../interfaces/StepCard.interface';

export const Container = styled.div<IStepCard>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 8px 16px;
  width: 146.8px;
  box-sizing: border-box;
  border-radius: 8px;
  transition: all 0.65s;
  ${({ status }) =>
    status == Status.INITIAL &&
    `
    background: ${theme.colors.primary.white};
    border: 1px solid rgba(223, 225, 226, 0.6);
    &:hover, 
    &:focus {
      background: ${theme.colors.secondary.gray600};
      border: 1px solid ${theme.colors.secondary.gray500};      
    }
  `}
  ${({ status }) =>
    status == Status.CURRENT &&
    `
    background: ${theme.colors.secondary.blue600};
    border: 1px solid ${theme.colors.secondary.blue500};  

    &:hover, 
    &:focus {
      background: ${theme.colors.secondary.blue550};
      border: 1px solid ${theme.colors.secondary.blue500};
    }
  `}
  ${({ status }) =>
    status == Status.DONE &&
    `
    background: ${theme.colors.secondary.green600};
    border: 1px solid ${theme.colors.secondary.green500};

    &:hover, 
    &:focus {
      background: ${theme.colors.secondary.green550};
      border: 1px solid ${theme.colors.secondary.green500};
    }
  `}
  ${({ status }) =>
    status == Status.DENIED &&
    `
    background: ${theme.colors.secondary.red600};
    border: 1px solid ${theme.colors.secondary.rose500};  
    &:hover, 
    &:focus {
      background: ${theme.colors.secondary.rose550}; 
      border: 1px solid ${theme.colors.secondary.rose500};  
    }
  `}
  ${({ status }) =>
    status == Status.WAIVER &&
    `
    
    background: ${theme.colors.secondary.purple600};
    border: 1px solid ${theme.colors.secondary.purple500};  
    
    &:hover, 
    &:focus {
      background: ${theme.colors.secondary.purple550}; 
      border: 1px solid ${theme.colors.secondary.purple500};  
    }
  `}
`;

export const IconContainer = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const Title = styled.label<IStepCard>`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.01em;
  ${({ status }) =>
    status == Status.INITIAL &&
    `
    color: ${theme.colors.secondary.gray200};
  `}
  ${({ status }) =>
    status != Status.INITIAL &&
    `
    color: ${theme.colors.primary.black};
  `}
`;

export const Days = styled.label<IStepCard>`
  display: block;
  width: 100%;
  text-align: center;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 10px;
  line-height: 16px;
  ${({ status }) =>
    status == Status.INITIAL &&
    `
    color: ${theme.colors.secondary.gray200};
    opacity: 0.6;
  `}
  ${({ status }) =>
    status != Status.INITIAL &&
    `
    color: ${theme.colors.primary.black};
    opacity: 0.6;
  `}
`;

const getBackgroundColor = (status: IStepCard) => {
  switch (status.status) {
    case Status.CURRENT:
      return theme.colors.secondary.blue400;
    case Status.DONE:
      return theme.colors.secondary.green350;
    default:
      return theme.colors.secondary.gray300;
  }
};

export const Number = styled.label<IStepCard>`
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: ${theme.colors.primary.white};
  border-radius: 8px;
  background-color: ${({ status }) => getBackgroundColor({ status })};
`;
